import optionGroup from '../select/src/option-group';
/* istanbul ignore next */
optionGroup.install = function(Vue) {
  Vue.component(optionGroup.name, optionGroup);
};

export default optionGroup;
